import { createContext } from 'react';

export interface GeolocationState {
  lat?: number;
  lng?: number;
  loading: boolean;
  granted: boolean;
  error: string | null;
}

export interface GeolocationContextValue extends GeolocationState {
  requestLocation: () => void;
}

export const GEOLOCATION_STORAGE_KEY = 'vira-tempo:geolocation';

export const GeolocationContext = createContext<GeolocationContextValue | null>(null);
